import axios from 'axios';
import { getApiUrl } from '../config/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const tripPlannerAPI = {
  generate: (payload) =>
    axios.post(getApiUrl('/api/trip-planner/generate'), payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  getMyPlans: () =>
    axios.get(getApiUrl('/api/trip-planner/my-plans'), { headers: authHeaders() }),

  getPlan: (id) =>
    axios.get(getApiUrl(`/api/trip-planner/${id}`), { headers: authHeaders() }),

  getSharedPlan: (token) =>
    axios.get(getApiUrl(`/api/trip-planner/shared/${token}`)),

  updatePlan: (id, payload) =>
    axios.patch(getApiUrl(`/api/trip-planner/${id}`), payload, {
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
    }),

  regenerate: (id) =>
    axios.post(getApiUrl(`/api/trip-planner/${id}/regenerate`), {}, { headers: authHeaders() }),

  share: (id) =>
    axios.post(getApiUrl(`/api/trip-planner/${id}/share`), {}, { headers: authHeaders() }),

  deletePlan: (id) =>
    axios.delete(getApiUrl(`/api/trip-planner/${id}`), { headers: authHeaders() }),
};

export default tripPlannerAPI;
